var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuadrosder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 150,
    viewBox: "0 0 146 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 100,
    height: 100,
    fill: "#71E3A6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 46,
    y: 50,
    width: 100,
    height: 100,
    fill: "#2AD0B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuadrosder);
export default __webpack_public_path__ + "static/media/Cuadros der.c5fb67d9ea6c3add8c06b75207ae8d14.svg";
export { ForwardRef as ReactComponent };